import { KnownDeliveryDtoDeliveryType, KnownKioskTransactionType } from '@groundfloor-platform/mgmt-service-g-sdk';

export const deliveryTypeToKioskTransactionTypeMap: Record<
  KnownDeliveryDtoDeliveryType,
  { deliver: KnownKioskTransactionType; collect: KnownKioskTransactionType }
> = {
  'inbound-dry-cleaning': {
    collect: KnownKioskTransactionType.CollectInboundDryCleaning,
    deliver: KnownKioskTransactionType.DeliverInboundDryCleaning
  },
  'inbound-mail': {
    collect: KnownKioskTransactionType.CollectInboundMail,
    deliver: KnownKioskTransactionType.DeliverInboundMail
  },
  'inbound-parcel': {
    collect: KnownKioskTransactionType.CollectInboundParcel,
    deliver: KnownKioskTransactionType.DeliverInboundParcel
  },
  'outbound-dry-cleaning': {
    collect: KnownKioskTransactionType.CollectOutboundDryCleaning,
    deliver: KnownKioskTransactionType.DeliverOutboundDryCleaning
  },
  'outbound-mail': {
    collect: KnownKioskTransactionType.CollectOutboundMail,
    deliver: KnownKioskTransactionType.DeliverOutboundMail
  },
  'peer-to-peer': {
    collect: KnownKioskTransactionType.CollectPeerToPeer,
    deliver: KnownKioskTransactionType.DeliverPeerToPeer
  },
  'retail-order': {
    collect: KnownKioskTransactionType.CollectClickAndCollect,
    deliver: KnownKioskTransactionType.DeliverClickAndCollect
  },
  // This mapping is just to keep the compiler happy. Lockerpoint orders should never be associated with kiosk transactions.
  'lockerpoint-order': {
    collect: KnownKioskTransactionType.CollectClickAndCollect,
    deliver: KnownKioskTransactionType.DeliverClickAndCollect
  }
};
